import { render, staticRenderFns } from "./proxyReport.vue?vue&type=template&id=4d83d021&scoped=true&"
import script from "./proxyReport.vue?vue&type=script&lang=js&"
export * from "./proxyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83d021",
  null
  
)

export default component.exports